import { autoserialize, autoserializeAs } from 'cerialize';
import { isNullOrUndefined, DateFormatConstants, DateUtil } from '@uzurv/core';

export class RideLimitDetail {
  @autoserialize
  organizationRiderId: number;

  @autoserialize
  riderRidesRemaining: number;

  @autoserialize
  riderRideLimitPeriod: string;

  @autoserializeAs(Date)
  riderRideLimitPeriodStartDate: Date;

  @autoserializeAs(Date)
  riderRideLimitPeriodEndDate: Date;

  @autoserialize
  organizationAmbulatoryRidesRemaining: number;

  @autoserialize
  organizationWavRidesRemaining: number;

  @autoserialize
  organizationRideLimitPeriod: string;

  @autoserializeAs(Date)
  organizationRideLimitPeriodStartDate: Date;

  @autoserializeAs(Date)
  organizationRideLimitPeriodEndDate: Date;

  static OnSerialized(instance: RideLimitDetail, json: any): void {
    if (!isNullOrUndefined(instance.riderRideLimitPeriodStartDate)) {
      json.riderRideLimitPeriodStartDate = DateUtil.serializeLocalDate(instance.riderRideLimitPeriodStartDate);
    }

    if (!isNullOrUndefined(instance.riderRideLimitPeriodEndDate)) {
      json.riderRideLimitPeriodEndDate = DateUtil.serializeDate(instance.riderRideLimitPeriodEndDate);
    }

    if (!isNullOrUndefined(instance.organizationRideLimitPeriodStartDate)) {
      json.organizationRideLimitPeriodStartDate = DateUtil.serializeDate(instance.organizationRideLimitPeriodStartDate);
    }

    if (!isNullOrUndefined(instance.organizationRideLimitPeriodEndDate)) {
      json.organizationRideLimitPeriodEndDate = DateUtil.serializeDate(instance.organizationRideLimitPeriodEndDate);
    }
  }

  static OnDeserialized(instance: RideLimitDetail, json: any): void {
    if (!isNullOrUndefined(json['riderRideLimitPeriodStartDate'])) {
      instance.riderRideLimitPeriodStartDate = DateUtil.deserializeLocalDate(json['riderRideLimitPeriodStartDate']);
    }

    if (!isNullOrUndefined(json['riderRideLimitPeriodEndDate'])) {
      instance.riderRideLimitPeriodEndDate = DateUtil.deserializeDate(json['riderRideLimitPeriodEndDate']);
    }

    if (!isNullOrUndefined(json['organizationRideLimitPeriodStartDate'])) {
      instance.organizationRideLimitPeriodStartDate = DateUtil.deserializeDate(json['organizationRideLimitPeriodStartDate']);
    }

    if (!isNullOrUndefined(json['organizationRideLimitPeriodEndDate'])) {
      instance.organizationRideLimitPeriodEndDate = DateUtil.deserializeDate(json['organizationRideLimitPeriodEndDate']);
    }
  }
}
